import React from "react";
import AuthPresenter from "./AuthPresenter";

// eslint-disable-next-line import/no-anonymous-default-export
export default class extends React.Component {
  render() {
    return <AuthPresenter />;
  }
}
